<template>
  <div />
</template>

<script>
import { track } from '@yxl/libs'
import qs from 'qs'
import { getRunningEnv } from 'lib/tools/getPlatform'
const isServer = process.env.VUE_ENV === 'server'

const mergeUrl = (url, params) => {
  return url + '?' + qs.stringify(params)
}

export default {
  preFetch() {
    return Promise.resolve()
  },

  beforeRouteEnter(to, from, next) {
    if (isServer) return next()
    const { type } = to.query
    const { env } = getRunningEnv()
    const s = env ? `-${env}` : ''
    if (type === 'newProfile') {
      track()
        .fetchAbtest({
          param_name: 'new_profile',
          default_value: 0,
          value_type: 'Number'
        })
        .then(result => {
          next(vm => {
            let url = ''
            if (result === 1) {
              url = mergeUrl(`/homepage/${to.query.userId}`, {
                redirect: 1,
                ...to.query
              })
              vm.$router.replace(url)
            } else {
              url = mergeUrl(
                `https://static${s}.xinli001.com/msite/index.html#/userIndex`,
                {
                  ...to.query,
                  hideNavigationBar: 1,
                  id: to.query.userId,
                  redirect: 1
                }
              )
              window.location.replace(url)
            }
          })
        })
    }
  }
}
</script>

<style></style>
